<template lang="pug">
  span(
    v-if="!onlyText"
    class="e-status-chip"
    :style="{ backgroundColor: currentStatus?.background, color: currentStatus?.color }"
  )
    span(
      class="e-status-chip__dot mr-2"
      :style="{ backgroundColor: currentStatus?.color }"
    )
    span {{ statusText }}
  span(
    v-else
    class="no-bg"
    :style="{ backgroundColor: currentStatus?.background, color: currentStatus?.color }"
  ) {{ statusText }}
</template>

<script>
export default {
  name: 'EStatusChip',
  props: {
    value: {
      type: [String, Boolean],
      default: ''
    },
    statuses: {
      type: Array,
      default: () => []
    },
    onlyText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentStatus() {
      return this.statuses.find(item => item.value === this.value)
    },
    statusText() {
      return this.currentStatus ? this.currentStatus.text : this.value
    }
  }
}
</script>

<style scoped lang="scss">
.e-status-chip {
  display: inline-block;
  border-radius: 20px;
  padding: 6px 12px;

  &__dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 100%;
  }
}

.no-bg {
  background: none !important;
}
</style>
